import { gql } from '@apollo/client';

export const CREATE_STYLE_VTON_IMAGE = gql`
    mutation createStyleVtonImage($input: CreateStyleVtonImageInput!) {
        createStyleVtonImage(input: $input) {
            userId
            styleId
            itemId
            url
            poseType
            taffiId
        }
    }
`;

export const GENERATE_POSE_VARIATION = gql`
    mutation generatePoseVariation($input: GeneratePoseVariationInput!) {
        generatePoseVariation(input: $input) {
            userId
            styleId
            itemId
            url
            poseType
            taffiId
        }
    }
`;
